/*
*预览图片缓存图片列表
*/
const state = {
    imageList:[],
    startPosition:0
};
const actions = {
    setPreviewImage({commit},value){
        commit('SET_PREVIEWIMAGE',value);
    }
}
const mutations = {
    SET_PREVIEWIMAGE(state,value){
        state.imageList = value.images;
        state.startPosition = value.startPosition?value.startPosition:0;
    },
}

export default{
	state,
	actions,
	mutations
}